import cssVars from '../../../styles/variables';

const partnerAuthSharedStyles = {
  textField: {
    backgroundColor: 'unset',
  },
  textFieldInput: {
    color: cssVars['--off-white'],
    height: '30px',
    fontFamily: 'inherit',
    fontSize: '18px',
    lineHeight: '18px',
    letterSpacing: '0.374px',
    padding: '0px',
    textAlign: 'left',
    border: 'none',
    fontWeight: '300',
    borderBottom: `1px solid ${cssVars['--ink-med-dark']}`,
  },
  labelStyle: {
    color: cssVars['--off-white'],
  },
  floatingLabelShrink: {
    fontSize: '16px',
    lineHeight: '18px',
    letterSpacing: '0.374px',
    textAlign: 'left',
    top: 2,
    left: 0,
    color: cssVars['--off-white'],
  },
  textFieldInputFocus: {
    border: 'none',
  },
  textFieldErrorState: {
    border: 'none',
  },
  inlineErrors: {
    textAlign: 'left',
  },
};

export const inputMappedPartnerAuthStyles = {
  style: partnerAuthSharedStyles.textField,
  inputStyle: partnerAuthSharedStyles.textFieldInput,
  inputFocusStyle: partnerAuthSharedStyles.textFieldInputFocus,
  floatingLabelStyle: partnerAuthSharedStyles.floatingLabelShrink,
  floatingLabelShrinkStyle: partnerAuthSharedStyles.floatingLabelShrink,
  inputErrorStyle: partnerAuthSharedStyles.textFieldErrorState,
  inlineErrorStyles: partnerAuthSharedStyles.inlineErrors,
};

export const inputCheckmarkSvgProps = {
  width: '20px',
  height: '15px',
  viewBox: '0 0 13 11',
  fill: cssVars['--off-white'],
};

export default partnerAuthSharedStyles;
